import { useMemo } from "react";
import { useApi } from './useApi.ts';
import { geoLocationApi } from '../api/apiClient.ts';

interface LocationSearchParams {
  name: string;
  count?: number;
}

interface LocationResult {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  country: string;
  admin1: string;
  admin2?: string;
  population?: number;
  timezone: string;
  feature_code?: string;
  elevation?: number;
}

interface LocationSearchResponse {
  results: LocationResult[];
  generationtime_ms?: number;
}

const validateSearchParams = (params: LocationSearchParams): boolean => {
  return typeof params.name === 'string' && params.name.length >= 3;
};

export const useLocationSearch = () => {
  const options = useMemo(() => ({
    initialData: { results: [] },
    debounceTime: 500,
    validateInput: validateSearchParams
  }), []);
  return useApi<LocationSearchResponse, LocationSearchParams>(geoLocationApi, options);
};